import clsx from 'clsx';

import styles from './ProductDescription.module.css';
import { ProductDescriptionProps } from './types';

const ProductDescription = ({ description, brandItemCode, className, layout, isReviewOrderPage, isShippingOptionPage }: Readonly<ProductDescriptionProps>) =>
  description && !isShippingOptionPage ? (
    <div
      className={clsx(styles.productDescription, className, {
        [styles.orderDetailsProductDescription]: layout === 'order-details',
        [styles.orderDetailsProductReviewDescription]: isReviewOrderPage,
      })}
    >
      {[brandItemCode, ...description].join(' • ')}
    </div>
  ) : null;

export default ProductDescription;
